import { render } from "./BulkExtract.vue?vue&type=template&id=5b92887e&scoped=true"
import script from "./BulkExtract.vue?vue&type=script&lang=js"
export * from "./BulkExtract.vue?vue&type=script&lang=js"

import "./BulkExtract.vue?vue&type=style&index=0&id=5b92887e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b92887e"]])

export default __exports__